import { Box, Text } from "@mantine/core";

const copyrightYear = new Date().getFullYear().toString();

/**
 * Displays the copyright footer using the year captured when this module was evaluated.
 */
const LayoutFooter = () => (
    <Box
        ta="center"
        pt="sm"
        mt="sm"
        mx="-sm"
        style={{ borderTop: "4px solid var(--mantine-color-primary-filled)" }}
    >
        <Text
            size="xs"
            c="dimmed"
        >
            Copyright&nbsp;&copy;&nbsp;{copyrightYear} Trans Tasman Radiation Oncology Group (TROG).
        </Text>
    </Box>
);

export default LayoutFooter;
